export function mlbHistoryNumber(entry, canonical, legacy = []) {
  const keys = [canonical, ...legacy];
  for (const key of keys) {
    const raw = entry?.[key];
    if (raw === null || raw === undefined || raw === "") continue;
    const value = Number(raw);
    if (Number.isFinite(value)) return value;
  }
  return null;
}

export const mlbPaValue = (entry) =>
  mlbHistoryNumber(entry, "PA", ["plateAppearances", "plate_appearances", "plate appearances"]);

export const mlbAbValue = (entry) =>
  mlbHistoryNumber(entry, "AB", ["atBats", "at_bats", "at bats"]);

